"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.save = void 0;
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var namespace = 'voyage-saver-meta';
var save = function () {
    var c = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    var _st = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    var d = {
        money: _st.money,
        crewAmount: diveCrew_hero_sidecar_1.diveCrew_hero.countLiveHeroes(),
        shipFilename: _st.shipFilename,
    };
    return d;
};
exports.save = save;
var load = function (d) {
    return d;
};
exports.load = load;
